import React, { useState, useEffect, Fragment } from 'react';
import { Select, Input, Button, Icon } from 'selfly-ui-react';

import { alarmCategories } from './alarmConfig';
import AlarmInfoModal from './alarmInfoModal.jsx';

const Organisations = props => {
    const organisationHandler = org => {
        if (!org.value) {
            return;
        }

        props.organisationChange(org);
    };
    return <Select options={props.organisations} onChange={org => organisationHandler(org)} />;
};

const InputField = props => {
    const [inputValues, setInputValues] = useState(props.inputs);

    /**when input is changed */
    const handleValueChange = (event, input) => {
        event.persist();
        const value = event.target.value;

        const newInputsArray = inputValues.find(el => {
            return input.index === el.index;
        });

        newInputsArray.value = value;

        setInputValues(prevState => {
            return prevState.map(state => {
                if (state.index === input.index) {
                    state.value = event.target.value;
                }
                return state;
            });
        });
    };

    useEffect(() => {
        props.inputUpdated(inputValues);
    }, [inputValues]);

    // when props change, re run the DOM rendering
    useEffect(() => {
        setInputValues(props.inputs);
    }, [props.inputs]);

    const onDelete = input => {
        const allData = [...inputValues];

        /**Filter the data which does not have the data to be deleted - empty input field */
        const newData = allData.filter(data => {
            return data.index !== input.index;
        });

        setInputValues(newData);
    };

    const inputDOM = input => (
        <div className="settings__item-alarm-config" key={input.index}>
            <Input
                className="settings__item-input"
                size="md"
                value={input.value}
                onChange={event => {
                    handleValueChange(event, input);
                }}
            />
            <Button
                className="settings__item-button"
                size="md"
                icon="delete_forever"
                onClick={() => onDelete(input)}
                type="negative"
                style={{ color: '#ffffff' }}
            />
        </div>
    );

    /**return DOM from all the input data */
    return inputValues.map(value => {
        return inputDOM(value);
    });
};

// SELECT ALARM CATEGORIES SUBSCRIPTIONS
const AlarmCategories = ({ alertTypes, updateAlertTypes, configId }) => {
    const [isAlarmInfoModalOpen, setIsAlarmInfoModalOpen] = useState(false);
    const [activeCategory, setActiveCategory] = useState();

    const onInfoButtonClick = category => {
        setActiveCategory(category);
    };

    useEffect(() => {
        setIsAlarmInfoModalOpen(true);
    }, [activeCategory]);

    const alarmCounts = {};
    alertTypes.map(type => {
        alarmCategories.map(category => {
            category.types.map(categoryType => {
                if (type.type.toLowerCase() === categoryType.type.toLowerCase() && type.severity.toLowerCase() === categoryType.severity.toLowerCase()) {
                    alarmCounts[category.name] = alarmCounts[category.name] === undefined ? 1 : alarmCounts[category.name] + 1;
                }
            });
        });
    });

    return (
        <Fragment>
            <div className="settings__item-label"> Select the alarm types ( {alertTypes.length} selected )</div>
            {activeCategory && (
                <AlarmInfoModal
                    isAlarmInfoModalOpen={isAlarmInfoModalOpen}
                    alarmInfoModalClose={() => {
                        setIsAlarmInfoModalOpen(false);
                        setActiveCategory(undefined);
                    }}
                    activeCategory={activeCategory}
                    alertTypes={alertTypes}
                    alertTypesChange={alerts => updateAlertTypes(alerts)}
                    configId={configId}
                />
            )}
            <div className="settings__item-alarms">
                {alarmCategories.map(category => (
                    <div className="settings__item-alarm-type" key={category.name}>
                        <Icon
                            onClick={() => {
                                onInfoButtonClick(category);
                            }}>
                            add_circle
                        </Icon>
                        {category.name}
                        {` (${alarmCounts[category.name] ? alarmCounts[category.name] : 0} / ${category.types.length})`}
                    </div>
                ))}
            </div>
        </Fragment>
    );
};

export { Organisations, InputField, AlarmCategories };
